import { render, staticRenderFns } from "./TermsIndex.vue?vue&type=template&id=83c8a2ce&scoped=true"
import script from "./TermsIndex.vue?vue&type=script&lang=js"
export * from "./TermsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c8a2ce",
  null
  
)

export default component.exports